import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';
import { END_TRANSACTION, START_TRANSACTION } from '@/forms/constants/services';

export default {
  startTransaction(payload) {
    return Repository.post('/income/verification/transaction/start/v1.0', { ...payload }, {
      params: getParams(START_TRANSACTION),
    });
  },
  completeTransaction(payload) {
    return Repository.post('/income/verification/transaction/complete/v1.0', { ...payload }, {
      params: getParams(END_TRANSACTION),
    });
  },
};
